export default class TimeoutUtility {
  static timeoutRef = null;

  static resetTimeout = (callback) => {
    clearTimeout(TimeoutUtility.timeoutRef);
    TimeoutUtility.timeoutRef = setTimeout(() => {
      // console.log("Automatic logout due to inactivity");
      if (callback && typeof callback === "function") {
        callback();
      }

      const userData = {
        user_id: null,
        token: null,
        user_name: null,
        user_profile: null,
        user_store_id: null,
        user_perm_id: [],
        fiscal_year: new Date().getFullYear(),
      };
      localStorage.setItem("userData", JSON.stringify(userData));
      window.location.reload();
    }, 3000 * 1000);
  };

  static attachEventListeners = (callback) => {
    const events = [
      "load",
      "mousemove",
      "mousedown",
      "click",
      "scroll",
      "keypress",
    ];
    events.forEach((event) => {
      window.addEventListener(event, () =>
        TimeoutUtility.resetTimeout(callback)
      );
    });
  };

  static removeEventListeners = () => {
    const events = [
      "load",
      "mousemove",
      "mousedown",
      "click",
      "scroll",
      "keypress",
    ];
    events.forEach((event) => {
      window.removeEventListener(event, TimeoutUtility.resetTimeout);
    });
  };
}
